import React from 'react';
import PropTypes from 'prop-types';

function RightStickBackground({ color, opacity }) {
  return (
    <>
      <path
        d="M441.97 309.927C441.97 343.998 469.592 371.617 503.659 371.617C537.73 371.617 565.352 343.998 565.352 309.927C565.352 300.667 563.308 291.883 559.654 284L528.106 253.27C520.609 250.031 512.346 248.237 503.659 248.237C469.592 248.237 441.97 275.857 441.97 309.927Z"
        fill={color}
        fillOpacity={opacity}
      />

      <path
        d="M461.304 304.458C461.304 327.078 479.64 345.415 502.261 345.415C524.881 345.415 543.216 327.078 543.216 304.458C543.216 281.838 524.881 263.5 502.261 263.5C479.64 263.5 461.304 281.838 461.304 304.458Z"
        fill="#020202"
      />
    </>
  );
}

RightStickBackground.propTypes = {
  color: PropTypes.string,
  opacity: PropTypes.number,
};

RightStickBackground.defaultProps = {
  color: '#32353A',
  opacity: 1,
};

export default RightStickBackground;
